// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--2def1"};